import type { Unit } from "../units/Unit";

const BAR_OFFSET_Y = -34 - 5 - 8; // just above the health bar
const PIP_H = 6;
const PIP_GAP = 3;
const TOTAL_W = 46;

export class CooldownBar {
  constructor(private unit: Unit) {}

  update(_dt: number): void {}

  draw(ctx: CanvasRenderingContext2D, centerX: number, centerY: number, alpha = 1): void {
    const cooldownMax = this.unit.def.abilityCooldown;
    if (cooldownMax <= 0) return;

    const turns = this.unit.cooldownTurns;
    const ready = turns === 0;
    const n = Math.max(1, cooldownMax);

    // Each pip width: distribute total width across n pips with gaps between them
    const pipW = (TOTAL_W - PIP_GAP * (n - 1)) / n;
    const startX = centerX - TOTAL_W / 2;
    const y = centerY + BAR_OFFSET_Y;

    ctx.save();
    ctx.globalAlpha = alpha;

    for (let i = 0; i < n; i++) {
      const px = startX + i * (pipW + PIP_GAP);
      // i < (cooldownMax - turns) means this pip is "charged" (elapsed turns)
      const charged = i < (cooldownMax - turns);

      if (charged) {
        ctx.fillStyle = ready ? "#f0e040" : "#c8a020";
        if (ready) {
          ctx.shadowColor = "#f0e040";
          ctx.shadowBlur = 10;
        } else {
          ctx.shadowBlur = 0;
        }
        ctx.fillRect(px, y, pipW, PIP_H);
      } else {
        // Empty pip: dark background with a visible inner border
        ctx.shadowBlur = 0;
        ctx.fillStyle = "#0e101a";
        ctx.fillRect(px, y, pipW, PIP_H);
        ctx.strokeStyle = "#3a3a5a";
        ctx.lineWidth = 1;
        ctx.strokeRect(px + 0.5, y + 0.5, pipW - 1, PIP_H - 1);
      }
    }
    ctx.shadowBlur = 0;

    // Turn count badge: show remaining turns when not ready
    if (!ready && turns > 0) {
      const label = `${turns}`;
      ctx.font = "bold 8px 'Inter', sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "rgba(200,180,100,0.9)";
      ctx.fillText(label, centerX + TOTAL_W / 2 + 7, y + PIP_H / 2);
    }

    ctx.restore();
  }
}
